import * as React from 'react';
import './applicationErrorSummary.module.scss';
const classNames = require('classnames');

export type ApplicationErrorSummaryType = 'normal' | 'complete';

type Props = {
  title: string;
  type: ApplicationErrorSummaryType;
};

export class ApplicationErrorSummary extends React.Component<Props> {
  render() {
    const { title, type = 'normal', children } = this.props;
    return (
      <div styleName={classNames('error-summary', type)}>
        <div styleName="header">
          <i className="fa fa-exclamation-triangle" styleName="icon" />
          {title}
        </div>
        <div styleName="body">{children}</div>
      </div>
    );
  }
}
